import React from 'react'
import { Checkbox, Spin, Modal } from 'antd'
import users from '@services/users'
import { alertPopup } from '@utils/popup'

// Toggle that marks an agent as collecting (is_collective). Only money/admin can change it; everyone sees it.
class CollectiveCheckbox extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            waiting: false
        }
    }

    save = is_collective => {
        const { agentId, updateInfo } = this.props

        this.setState({ waiting: true })
        users
            .updateCollective({ agent_id: agentId, is_collective })
            .then(() => {
                if (updateInfo) return updateInfo()
            })
            .catch(() => alertPopup({ type: 'error', title: 'שגיאה בעדכון קולקטיב', body: '' }))
            .finally(() => this.setState({ waiting: false }))
    }

    handleChange = checked => {
        Modal.confirm({
            className: 'collective-confirm-modal',
            title: checked ? 'להפעיל קולקטיב לסוכן?' : 'לכבות קולקטיב לסוכן?',
            okText: 'אישור',
            cancelText: 'ביטול',
            okButtonProps: { className: 'collective-confirm-submit' },
            cancelButtonProps: { className: 'collective-confirm-cancel' },
            onOk: () => this.save(checked)
        })
    }

    render() {
        const { waiting } = this.state
        const { agentInfo = {}, canEdit = false } = this.props
        const loadingValue = agentInfo.is_collective === undefined

        return (
            <div style={{ display: 'flex' }}>
                <span style={{ ...style.box, ...style.rightBox }}>
                    {waiting || loadingValue ? (
                        <Spin size="small" />
                    ) : (
                        <Checkbox
                            disabled={!canEdit}
                            onChange={e => this.handleChange(e.target.checked)}
                            checked={!!agentInfo.is_collective}
                        />
                    )}
                </span>
                <span style={{ ...style.box, ...style.leftBox }}>
                    <span className="collective-checkbox-label">{'קולקטיב'}</span>
                </span>
            </div>
        )
    }
}

const style = {
    box: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '34px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    },
    rightBox: { cursor: 'pointer', borderRadius: '0 4px 4px 0' },
    leftBox: { cursor: 'pointer', borderRadius: '4px 0 0 4px', width: 'fit-content' }
}

export default CollectiveCheckbox
